import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, unref as _unref, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = ["onClick"];
const _hoisted_2 = {
  class: "leading-5"
};
const _hoisted_3 = {
  key: 0,
  class: "text-stone-500 font-normal"
};
const _hoisted_4 = {
  class: "flex items-center"
};
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "italic"
}, "end career", -1);
const _hoisted_6 = {
  class: "flex-center mb-4"
};
import Modal from "@/modules/vue/components/Modal.vue";
import { app } from "@/di";
import { Team } from "@/modules/team/entity";
import { StaffNegotiationStarter } from "@/modules/staff/services/StaffNegotiationStarter";
import { StaffMemberTransferator } from "@/modules/staff/services/StaffMemberTransferator";
import { NegotiationStatusEnum } from "@/modules/diplomacy/enums";
import NegotiationFields from "@/modules/diplomacy/components/NegotiationFields.vue";
import FormGroup from "@/modules/vue/components/FormGroup.vue";
import PlayerInfo from "@/modules/team/components/PlayerInfo.vue";
import Icon from "@/modules/vue/components/Icon.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'StaffMemberLink',
  props: {
    entity: null,
    orientation: {
      default: 'left'
    }
  },
  setup(__props) {
    const props = __props;
    const negotiation = ref();
    const router = useRouter();
    const negotiate = async () => {
      const negotiation = await app.get(StaffNegotiationStarter).start(await Team.current(), props.entity);
      await router.push({
        name: 'negotiations.show',
        params: {
          id: negotiation.id
        }
      });
    };
    const sack = async () => {
      await app.get(StaffMemberTransferator).sack(props.entity);
    };
    const modal = ref(null);
    const onClickLink = async () => {
      await props.entity.load(['team', 'negotiations']);
      for (const n of props.entity.negotiations) {
        await n.load('team');
        if (n.team.isCurrent) {
          negotiation.value = n;
        }
      }
      modal.value.show();
    };
    const onClickNegotiation = () => {
      modal.value.show();
      router.push({
        name: 'negotiations.show',
        params: negotiation.value
      });
    };
    const endCareer = async () => {
      props.entity.endsCareer = true;
      await props.entity.save();
    };
    return (_ctx, _cache) => {
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("a", {
        href: "#",
        class: _normalizeClass(["font-semibold", {
          'text-blue-600': !__props.entity.endsCareer,
          'text-red-600': __props.entity.endsCareer
        }]),
        onClick: _withModifiers(onClickLink, ["prevent", "stop"])
      }, _toDisplayString(__props.entity.shortName) + " (" + _toDisplayString(__props.entity.age) + ") | " + _toDisplayString(__props.entity.constructor.name), 11, _hoisted_1), _createVNode(Modal, {
        ref_key: "modal",
        ref: modal
      }, {
        title: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('staff_members')), 1), __props.entity ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.entity.name), 1)) : _createCommentVNode("", true)])]),
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_4, [__props.entity.team && __props.entity.team.isCurrent ? (_openBlock(), _createBlock(_component_NButton, {
          key: 0,
          secondary: "",
          type: "error",
          class: "mr-2",
          onClick: sack
        }, {
          default: _withCtx(() => [_createVNode(Icon, {
            icon: _ctx.IconEnum.DocumentBulletListOff20Regular
          }, null, 8, ["icon"])]),
          _: 1
        })) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [negotiation.value ? (_openBlock(), _createBlock(_component_NButton, {
          key: 0,
          type: negotiation.value.status === _unref(NegotiationStatusEnum).OPENED ? 'success' : 'error',
          class: "mr-2",
          onClick: onClickNegotiation
        }, {
          default: _withCtx(() => [_createVNode(Icon, {
            icon: _ctx.IconEnum.Handshake20Regular
          }, null, 8, ["icon"])]),
          _: 1
        }, 8, ["type"])) : (_openBlock(), _createBlock(_component_NButton, {
          key: 1,
          secondary: "",
          type: "success",
          class: "mr-2",
          onClick: _withModifiers(negotiate, ["stop"])
        }, {
          default: _withCtx(() => [_createVNode(Icon, {
            icon: _ctx.IconEnum.Handshake20Regular
          }, null, 8, ["icon"])]),
          _: 1
        }, 8, ["onClick"]))], 64)), _ctx.$debug && !__props.entity.endsCareer ? (_openBlock(), _createBlock(_component_NButton, {
          key: 2,
          secondary: "",
          type: "error",
          class: "mr-2",
          onClick: endCareer
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        })) : _createCommentVNode("", true)])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(PlayerInfo, null, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.entity.skill), 1)]),
          _: 1
        })]), _createVNode(FormGroup, {
          label: _ctx.$t('type')
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.entity.constructor.name), 1)]),
          _: 1
        }, 8, ["label"]), _createVNode(FormGroup, {
          label: _ctx.$t('name')
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.entity.name), 1)]),
          _: 1
        }, 8, ["label"]), _createVNode(FormGroup, {
          label: _ctx.$t('team')
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.entity.team ? __props.entity.team.name : '--'), 1)]),
          _: 1
        }, 8, ["label"]), _createVNode(FormGroup, {
          label: _ctx.$t('age')
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.entity.age), 1)]),
          _: 1
        }, 8, ["label"]), _createVNode(FormGroup, {
          label: _ctx.$t('market_value')
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$money(__props.entity.marketValue)), 1)]),
          _: 1
        }, 8, ["label"]), _createVNode(NegotiationFields, {
          entity: __props.entity
        }, null, 8, ["entity"])]),
        _: 1
      }, 512)], 64);
    };
  }
});